// Per-type equipment / utility icons. Mirrors trusstor_dashboard's
// `shared/utils/equipment.utils.ts -> getEquipmentIconFromType`. Imports
// resolve to URLs at build time (Vite asset pipeline) so the icons can
// be used as `<img src={…}>` sources in the slab + drawer chip overlays.

import { EquipmentTypes, UtilityTypes } from '@d-orca/shared/trusstor';

import bondingMachinery from '@assets/icons/equipment/bonding-machinery.png';
import electricity from '@assets/icons/equipment/electricity.png';
import heavy from '@assets/icons/equipment/heavy.png';
import height from '@assets/icons/equipment/height.png';
import movingLifting from '@assets/icons/equipment/moving-lifting.png';
import optic from '@assets/icons/equipment/optic.png';
import pavingTiling from '@assets/icons/equipment/paving-tiling.png';
import power from '@assets/icons/equipment/power.png';
import safety from '@assets/icons/equipment/safety.png';
import scissorsLift from '@assets/icons/equipment/scissors-lift.svg';
import waterDrainage from '@assets/icons/equipment/water-drainage.png';
import welding from '@assets/icons/equipment/welding.png';

export function getEquipmentIconFromType(type: EquipmentTypes | UtilityTypes): string {
  switch (type) {
    case EquipmentTypes.Height:
      return height;
    case EquipmentTypes.BondingMachinery:
      return bondingMachinery;
    case EquipmentTypes.Electricity:
      return electricity;
    case EquipmentTypes.HeavyEquipment:
      return heavy;
    case EquipmentTypes.MovingLifting:
      return movingLifting;
    case EquipmentTypes.Optics:
      return optic;
    case EquipmentTypes.PavingTiling:
      return pavingTiling;
    case EquipmentTypes.PowerTools:
      return power;
    case EquipmentTypes.Safety:
      return safety;
    case EquipmentTypes.Welding:
      return welding;
    case EquipmentTypes.WaterDrainage:
      return waterDrainage;
    case UtilityTypes.scissorsLift:
      return scissorsLift;
    // EquipmentTypes.ScissorsLift uses the same icon as the utility — it's
    // the same asset upstream.
    case EquipmentTypes.ScissorsLift:
      return scissorsLift;
    // Hoist has no dedicated icon in trusstor's set; trusstor's
    // FloorUtilitiesSection routes hoists through the same EquipmentIcon
    // (default fallback = power).
    default:
      return power;
  }
}
